import { FormField } from '@/types';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import SelectFieldComponent from './SelectFieldComponent';

function SelectField(props: FormField) {
  const { choices, clean_name: cleanName, label, default_value: defaultValue } = props;

  const router = useRouter();
  const defaultParamSelection = router.query.selection;
  const [defaultParam, setDefaultParam] = useState(
    defaultParamSelection && typeof defaultParamSelection === 'string'
      ? defaultParamSelection
      : null,
  );

  useEffect(() => {
    setDefaultParam(
      defaultParamSelection && typeof defaultParamSelection === 'string'
        ? defaultParamSelection
        : null,
    );
  }, [defaultParamSelection]);

  return (
    <SelectFieldComponent
      key={defaultParam}
      choices={choices}
      default_value={
        defaultParam && choices.split(',').includes(defaultParam) ? defaultParam : defaultValue
      }
      label={label}
      clean_name={cleanName}
    />
  );
}

export default SelectField;
